export interface GenesisAdminState {
    appLoaded: boolean;
}
